module.exports = __webpack_public_path__ + "static/img/1960_01_26_NYTimes_IndeterminacyReview.72be9b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1960_01_26_NYTimes_IndeterminacyReview.jpg
// module id = 9Bd0
// module chunks = 0